import { jsx as _jsx } from "react/jsx-runtime";
import { SDUIProductTileImpressionProvider } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/SDUIProductTileImpressionProvider";
import { SDUIGridV2AutoColumnLayoutBase } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Grid/__internal__/GridV2/SDUIGridV2AutoColumnLayoutBase";
import { SDUIGridV2FixedColumnLayoutBase } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Grid/__internal__/GridV2/SDUIGridV2FixedColumnLayoutBase";
import React from "react";
export var SDUIGridV2Renderer = function(param) {
    var component = param.component, loggingData = param.loggingData, renderBehaviour = param.renderBehaviour;
    var gridElement = component.grid_component;
    var isRequiredForInteractivity = component.is_required_for_interactivity;
    if (!gridElement || !gridElement.column_layout || gridElement.tiles === undefined || gridElement.tiles.length === 0) {
        return null;
    }
    return /*#__PURE__*/ _jsx(SDUIProductTileImpressionProvider, {
        loggingData: loggingData,
        children: gridElement.column_layout.auto ? /*#__PURE__*/ _jsx(SDUIGridV2AutoColumnLayoutBase, {
            loggingData: loggingData,
            gridComponent: gridElement
        }) : /*#__PURE__*/ _jsx(SDUIGridV2FixedColumnLayoutBase, {
            loggingData: loggingData,
            gridComponent: gridElement,
            isRequiredForInteractivity: isRequiredForInteractivity,
            renderBehaviour: renderBehaviour
        })
    });
};
